var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgC8(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36.23 36.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "-C8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.29,35.15l-8.5-8.66L4.9,25.37c1.35,1.15,2.87,2.9,4.2,4.21s3.56,3.83,4.4,4.28l1.21-1.12L6.28,24.13l1-1.12a52.6,52.6,0,0,1,4.27,4.21c.81.79,3.6,3.87,4.33,4.24l1.1-1-8.53-8.7,1.11-1a115.57,115.57,0,0,1,8.49,8.51l1.27-1.19L11,19.48l1-1.12,8.49,8.48,1.38-1.15L13.33,17l1.12-1c.66.35,7.47,7.44,8.5,8.49l1.34-1.25-8.43-8.55L17,13.47l8.46,8.62L26.63,21,18.27,12.4l1-1.25c1.41,1.25,2.85,2.9,4.21,4.26s3.11,3.56,4.38,4.25l1.33-1.24L20.67,9.78,21.78,8.7c1.3,1.05,2.94,2.9,4.22,4.2s3.05,2.91,4.24,4.36L31.57,16,23.15,7.4l1.14-1.18,8.44,8.6L34,13.66l-8.4-8.55,1-1.21,8.49,8.56,1.11-1C35.28,8,31.91,1.67,28.35.19c-1.47-.61-2.54.39-4.07,1.45a105.56,105.56,0,0,0-14.2,12C7.7,16,.35,24.55,0,26.71-.54,30.5,7.78,35.24,10.61,36c.86.23.93-.21,1.68-.84Z",
    transform: "translate(0 -0.01)",
    fill: "#131e2f",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgC8);
export default __webpack_public_path__ + "static/media/C8.84a71b146d966b051583d6cfb39114e0.svg";
export { ForwardRef as ReactComponent };